package uz.ferro.erp.feature.product.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.model.DataFile
import uz.ferro.erp.model.DictItem

@Serializable
data class Product(
    val id: Long? = null,
    val externalId: String? = null,
    val type: ProductType? = null,
    val familyId: Long? = null,
    val providerId: Long? = null,
    val title: DictItem? = null,
    val sellingPrice: Double? = null,
    val localSellingPrice: Double? = null,
    var dealersPrice: Double? = null,
    var dealerReward: Double? = null,
    var providerPrice: Double? = null,
    var providerCurrency: String? = null,
    var disabled: Boolean = false,
    var logo: DataFile? = null,
    var description: DictItem? = null,
    var regions: List<ProductRegion>? = null,
    var countries: List<ProductCountry>? = null,
    var properties: List<ProductProperty>? = null
)
